export default {
    //Google Play
    googlePlay: 'monitor/googlePlay',
    addGooglePlayApp: 'monitor/addGooglePlayApp',

    //Web Changes
    setupInitialScreen: 'monitor/setupInitialScreen',
    latestScreen: 'monitor/latestScreen',
    
    listSites: 'monitor/listSites',
    addSite: 'monitor/addSite',
    deleteSite: 'monitor/deleteSite',
    editSite: 'monitor/editSite'
}